import { makeObservable, observable, computed, action } from 'mobx';
import bucketList from './BucketList';
import { erpApiurl } from '../stores/APIEndpoints';

const PENDING = 'pending';
const DONE = 'done';
const ERROR = 'error';

const EMPTY_MESSAGE = { status: "", help: "" };
const ERROR_MESSAGE = { status: "error", help: "Unable to fetch the Payables. The Service is unavailable. Please try after sometime." };

export default class PayableControlStore {

    state = PENDING;
    message = EMPTY_MESSAGE;
    payables = [];
    filteredPayables = [];
    branchList = [
        {
            value: 0, label: 'All Branch'
        }
    ];
    settlementTypeList = [
        {
            value: 'daily', label: 'Daily'
        },
        {
            value: 'monthly', label: 'Monthly'
        }
    ];
    bucketList = [
        {
            value: 0, label: 'All',
            
        }
    ];
    rowCount = 0;
    totalPayableSum = 0;
    bucket = 'All';
    referrerId = 0;
    settlementType = '';

    constructor(props) {
        this.apiProxy = props.apiProxy;
        this.collectionType = props.collectionType;
        this.stores = props.stores;

        this.bucket = new bucketList();

        this.bucket.getDateData(this.bucketList);

        makeObservable(this, {
            state: observable,
            message: observable,
            payables: observable,
            rowCount: observable,
            filteredPayables: observable,
            bucketList: observable,
            bucket: observable,
            referrerId: observable,
            settlementType: observable,

            isLoading: computed,
            isError: computed,
            isDone: computed,

            fetchPayableSummary: action,
            publishToStores:action,
            GetallBranchName: action,
        });
    }


    get isLoading() {
        return this.state === PENDING;
    }

    get isError() {
        return this.state === ERROR;
    }

    get isDone() {
        return this.state === DONE;
    }

    GetallBranchName = async() => {
  
        const payload = {
            BranchId:0,
        }

        const reportUrl = `${erpApiurl}api/carbon/LTBranchDetails`;
        const response = await this.apiProxy.asyncPost(reportUrl,payload);
        const branches = await response.json();


        branches.map((branch) =>
            {const branchVal = {
                value: branch.BranchId,
                label: branch.BranchName
            }   

            this.branchList.push(branchVal)}
        );

    }   

    regenerateIc = async(startDate, endDate) => {

        const payload = {
            fromdate:startDate,
            todate:endDate,
            paymentType: this.settlementType,
            ReferrerId:this.referrerId
        }

        const reportUrl = `${erpApiurl}api/Carbon/RegenerateIC`;
        const response = await this.apiProxy.asyncPost(reportUrl,payload);
        const message = await response.text();

        alert(message)
    }   

    filterBranch = (value) => {

        let payData = this.payables;

        if(value !== 0) {
            payData = this.payables.filter((ele) => (ele.BranchId === value));
        }

        this.totalPayableSum =  payData.map(item => item.Payable).reduce((a, b) => a + b, 0);

        this.rowCount = payData.length;

        this.filteredPayables = payData;
    }

    /**
     * Send the request to the endpoint using the FetchAPI
     * 
     */
     fetchPayableSummary = async () => {

        const url = `${erpApiurl}api/Carbon/GetIcSummary?collectionType=${this.collectionType}`;
        this.state = PENDING;
        this.message = EMPTY_MESSAGE;

        try {
            const response = await this.apiProxy.getAsync(url);
            const data = await response.json();

            if (data.Message) {
                this.message = ERROR_MESSAGE;
                this.state = DONE;
                return;
            }

            this.payables = data;
            this.filteredPayables = data;
            this.rowCount = data.length;
            this.totalPayableSum = 0;

            const errorReffererIds = new Set();
            for(let i=0;i<data.length;i++) {
                const payable = data[i];
                this.totalPayableSum = this.totalPayableSum + payable.Payable;
                errorReffererIds.add(payable.ReferrerId);
            };
 
            this.publishToStores(errorReffererIds);
            this.state = DONE;
        }
        catch (e) {
            this.state = ERROR;
            this.message = ERROR_MESSAGE
            console.log(e);
        }
    }

    publishToStores = (errorReffererIds) => {
        for(let i=0;i<this.stores.length;i++) {
            this.stores[i].errorReffererIds = errorReffererIds;
            this.stores[i].fetchPayableSummary();
            this.stores[i].GetallBranchName();
        }
    }
}
